module.exports = __webpack_public_path__ + "img/nature6.3074de2d.jpg";